import { __assign, __rest } from "tslib";
import React from 'react';
import { getBaseProps } from '../internal/base-component';
import InternalGrid from './internal';
import { useContainerBreakpoints } from '../internal/hooks/container-queries';
import { useTelemetry } from '../internal/hooks/use-telemetry';
export default function Grid(_a) {
    var _b = _a.gridDefinition, gridDefinition = _b === void 0 ? [] : _b, _c = _a.disableGutters, disableGutters = _c === void 0 ? false : _c, children = _a.children, restProps = __rest(_a, ["gridDefinition", "disableGutters", "children"]);
    useTelemetry('Grid');
    var baseProps = getBaseProps(restProps);
    var _d = useContainerBreakpoints(), breakpoint = _d[0], ref = _d[1];
    return (React.createElement(InternalGrid, __assign({}, baseProps, { ref: ref, breakpoint: breakpoint, gridDefinition: gridDefinition, disableGutters: disableGutters }), children));
}
//# sourceMappingURL=index.js.map